import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getCompositionsOptions(
  params: Parameters<typeof service.getMutationCompositions>[number],
) {
  return queryOptions({
    queryFn: () => service.getMutationCompositions(params),
    queryKey: ['getMutationCompositions', params.cartGuid, params.customerGuid],
    gcTime: 0,
  });
}
